import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { DeepCopyPipe } from '@quorum/common-pipes';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromLocalSettings from './local-settings.actions';
import { LocalSettingsState, localSettingsStateSelector } from './local-settings.interfaces';
import { persistedSubsetUnchanged, pickPersistedSettings } from './local-settings.util';

export interface LocalSettingsToast {
  message: string;
  actionText: string;
  options?: { duration?: number; panelClass?: string | string[] };
}

@Injectable()
export class LocalSettingsStateService {
  private toastSubject = new Subject<LocalSettingsToast>();

  constructor(private store: Store<any>) {}

  selectLocalSettingsFromState() {
    return this.store.pipe(
      select(localSettingsStateSelector),
      map((localSettings) => {
        return new DeepCopyPipe().transform(localSettings);
      })
    );
  }

  updateLocalSettingsInState(localSettings: any) {
    this.store.dispatch(new fromLocalSettings.UpdateLocalSettingsInState(localSettings));
  }

  saveSalesPlannerUserSettings(localSettings: LocalSettingsState, previousLocalSettings?: LocalSettingsState) {
    // Skip the PUT (and the success toast that would imply something was saved) when the user's
    // dialog edits only touched session-only fields like activitiesFilter, prospectFilter,
    // prospectSortBy, or startDate. pickPersistedSettings drops those, so an unchanged subset
    // means the server-side record would be byte-identical to what's already stored.
    if (previousLocalSettings && persistedSubsetUnchanged(previousLocalSettings, localSettings)) {
      return;
    }
    this.store.dispatch(
      new fromLocalSettings.SaveSalesPlannerUserSettingsToServer(pickPersistedSettings(localSettings))
    );
  }

  addToast(toast: LocalSettingsToast) {
    this.toastSubject.next(toast);
  }

  listenForToasts(): Observable<LocalSettingsToast> {
    return this.toastSubject.asObservable();
  }

  isEmpty(obj: any) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }
}
